<template>
	<BaseChart :option="finalOption" />
</template>

<script>
	export default {
		name: 'PieChart',
		props: {
			categories: {
				type: Array,
				default: () => [],
			},
			option: Object,
			height: String,
			rate: { type: Boolean, default: false },
			title: {
				type: String,
				default: '合同总数',
			},
			unit: { type: String, default: '' },
		},

		computed: {
			total() {
				return this.categories.reduce((sum, item) => sum + item.value, 0);
			},
			baseOption() {
				return {
					color: ['#FFB579', '#6296FF', '#5AE88E', '#8A7CFE', '#78D9FF', '#FF8AB8', '#81FFFB', '#B3D5FF'],
					tooltip: {
						trigger: 'item',
					},
					legend: {
						orient: 'vertical',
						right: '7%',
						top: 'center',
						data: this.categories.map(i => i.name),
						itemWidth: 14,
						formatter: name => {
							if (!this.rate) return name;
							const item = this.categories.find(i => i.name === name);
							return `${name}  ${item ? item.value : 0} ${this.unit}`;
						},
					},
					series: [
						{
							type: 'pie',
							center: ['25%', '50%'],
							radius: ['52%', '70%'],
							label: {
								show: true,
								position: 'center',
								formatter: params => {
									if (this.rate) {
										return `{value|${((params.value / this.total) * 100).toFixed(2)}%}\n{title|${this.title}}`;
									}
									return `{value|${this.total}}\n{title|${this.title}}`;
								},
								rich: {
									title: { fontSize: 10, color: '#64748B', lineHeight: 20 },
									value: { fontSize: 20, fontWeight: 'bold' },
								},
							},
							data: this.categories,
						},
					],
				};
			},

			finalOption() {
				return this.merge(this.baseOption, this.option);
			},
		},

		methods: {
			merge(base, custom) {
				if (!custom) return base;

				return {
					...base,
					...custom,
					legend: {
						...base.legend,
						...(custom.legend || {}),
					},
					series: base.series.map((item, i) => ({
						...item,
						...(custom.series && custom.series[i]),
					})),
				};
			},
		},
	};
</script>
